// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48f1d382","243":"6798daff","732":"5d81cd4c","977":"edf7bfb3"}[chunkId] + ".chunk.js";
};